module.exports = __webpack_public_path__ + "static/media/2.5cf0d359.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/2.png
// module id = 1302
// module chunks = 0